export default __webpack_public_path__ + "static/4-161b66fc3ddabab90176c4f2ce67297d.jpeg";